import { Box, Button, CardMedia, CircularProgress, Grid, IconButton, Skeleton, Theme, Tooltip, Typography, useTheme } from '@mui/material';
import { Notes, ProceedSaveLater, SubHeading } from './components';
import {
  Formik,
  FormikHelpers,
  setNestedObjectValues,
  useField,
  validateYupSchema,
  yupToFormErrors,
} from 'formik';
import MFSelectField from '../../lib/formik/SelectField';
import React, { useEffect, useState } from 'react';
import {
  ADDRESS_SAME_DOCS,
  AddressProofsMasters,
  ALWAYS_SHOW_DOCS,
  AMC_APPROVER_CHECK_FOR_INDIVIDUAL,
  applicantStatusMasters,
  APPLICATION_TYPE_FOR_DOCUMENTS,
  BankAccountProofsMasters,
  DIGITAL_KYC_DOCS,
  DISABLE_NOMINEE_OPY_OUT,
  ENABLE_KRA_DOCUMENT_FETCH,
  IdentityProofsMasters,
  IMAGE_UPLOAD_FORMATS,
  INVESTOR_IMAGE_UPLOAD_FORMATS,
  NEXEDGE_INVESTMENT_PREFERENCE,
  ONBOARDING_DEMAT_DETAILS,
  onboardingTypeMasters,
  USER_ROLES,
} from '../../utils/constant';
import { useDispatch, useSelector } from 'react-redux';
import { RootStateType } from '../../redux-store/reducers';
import {
  Applicant,
  Bank,
  DataMasters,
  Document,
  DocumentType,
  FileType,
  individuals_Poa_nonIndividuals_Documents,
  KraDocumentType,
  NomineeType,
  RiskProfileMaster,
} from '../../redux-store/types/api-types';
import {
  getDocuments,
  isFormValidForSubmission,
  updateApplication,
} from '../../redux-store/actions/application';
import { useHistory, useRouteMatch } from 'react-router';
import { FilePond, registerPlugin } from 'react-filepond';
import 'filepond/dist/filepond.min.css';
import FilePondPluginImageExifOrientation from 'filepond-plugin-image-exif-orientation';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
import FilePondPluginFileValidateSize from 'filepond-plugin-file-validate-size';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css';
import { documentDetailsSchema } from '../../utils/schema';
import { logout, showError } from '../../redux-store/actions/auth';
import {
  formatFileSize,
  getApplicantName,
  isMinor,
  isOnboardingTypeMinor,
  saveForLater,
  sendApplication_Nri,
  sendRoleBasedStatus,
} from '../../utils/utilityFunctions';
import { getFieldTitle } from '../ApplicationDetails/DocumentDetails';
import { setLabels } from 'react-chartjs-2/dist/utils';
import { applicationComparison, applyRoleBasedStatus } from '../../utils/utilityFunctions';
import { useSnackbar } from 'notistack';
import {
  getMaskedAadhaar,
  // getNationalityList,
  MaskedAadhaarResponse,
  riskProfileMasterData,
} from '../../redux-store/actions';
import { nationaliyType } from '../../redux-store/types/mdms';
import { KraDocument } from './kraDocument';
import { LoadingButton } from '@mui/lab';
import { SearchableSelect } from '../../lib/formik/searchSelectField';
import { DeleteIcon1, DeleteIconFilled, DownloadIcon, InfoIconFilled } from '../../assets/SvgIcons';
import { TextDatePicker } from '../onboarding/DatePickerWithTextFeild';
import dayjs, { Dayjs } from 'dayjs';
import { DeleteIcon } from '../customSVGs';
import { getDataMasters } from '../../redux-store/actions/onBoarding';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';

registerPlugin(
  FilePondPluginImageExifOrientation,
  FilePondPluginImagePreview,
  FilePondPluginFileValidateSize,
  FilePondPluginFileValidateType
);

export const FileUpload = ({
  onFileChange,
  name,
  documentData,
  disabled,
  onFileUpload,
  onFileUploaded,
  fileUploadFormats,
  maxUploadFiles,
  maxFileSize,
  minFileSize,
  multipleFilesCheck,
  children,
}: {
  onFileChange: (value: string, documentId: string, removeFile?: boolean) => void;
  name: string;
  documentData: documentDetails;
  disabled: boolean;
  onFileUpload: () => void;
  onFileUploaded: () => void;
  fileUploadFormats: string[];
  maxUploadFiles: number;
  maxFileSize: string;
  minFileSize: string | null;
  multipleFilesCheck: string;
  children?: React.ReactNode;
}): JSX.Element => {
  const dispatch = useDispatch()
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const theme = useTheme();
  const [field, meta] = useField(name);
  const errorText = meta.error && meta.touched ? meta.error : '';
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [files, setFiles] = useState<any>([]);
  const authToken = useSelector((store: RootStateType) => store.auth.token);

  const handleFileChange = (name: string, documentId: string) => {

    try {
      onFileChange(name, documentId);
    } catch (e) {
      onFileUploaded();
      console.error((e as Error).message);
    }
  };
  return (
    <>
      {!documentData.file ? (
        <Grid container
          sx={(theme: Theme) => ({
            background: theme.palette.common.white,
            border: `0.5px solid ${theme.palette.text.secondary}80`,
            padding: '10px',
            borderRadius: "10px",
            rowGap: "10px",
            // background: 'red',
            '.filepond--root': {
              fontFamily: `${theme.typography.fontFamily}`,
              width: '100%',
              // height: '49px',
            },
            '.filepond--panel-root': {
              background: theme.palette.common.white,
              // border: `0.5px solid ${theme.palette.text.secondary}80`,
              // padding: '30px',
            },
            '.filepond--credits': { display: 'none' },
            '.filepond--label-action': {
              color: `${theme.palette.primary[500]}`,
              fontFamily: `${theme.typography.fontFamily}`,
              letterSpacing: '0.2px',
              cursor: 'pointer',
              textDecoration: "none",
              fontSize: '14px',
              fontWeight: '500',
            },
            '.filepond--label-format': {
              color: `${theme.palette.text.secondary}`,
              fontWeight: '400',
              paddingLeft: '3px'
            },
            '.filepond-subheading': {
              fontWeight: '400',
              color: `${theme.palette.text.secondary}`,
              fontSize: '12px',
            },
            '.filepond--drop-label': {
              cursor: disabled ? 'not-allowed' : 'pointer',
              pointerEvents: 'all',
              width: '100%',
            },
            '.filepond--drop-label label': {
              width: '100%',
            },
            '.filepond--file': {
              color: '#000',
              flexWrap: 'wrap',
              fontWeight: 500,
            },
            '.filepond--file-wrapper': {
              backgroundColor: theme.palette.primary[50],
            },
            '.filepond--hopper': {
              height: 'auto',
              marginBottom: '0px',
            },
            '.delete-icon-container': {
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              backgroundColor: "primary.100",
              borderRadius: "50%",
              padding: "5px",
              cursor: "pointer"
            },
            '.filepond--image-preview-overlay-success': {
              color: theme.palette.primary[100],
            },
            '.handle-label-orientation': {
              width: "100%",
              display: "flex",
              // justifyContent: "flex-start",
              // gap: "10px",
              justifyContent: "space-between",
              flexDirection: "row",
              alignItems: "center",
            },
            // pt: 3,
          })}
        >
          <Grid item xs={12}>
            {disabled ? <Typography variant="overline_600" color="text.disabled" sx={{ display: "flex", alignItems: "center", gap: "12px" }}>
              {/* <Box
                width={40}
                height={40}
                borderRadius={1}
                bgcolor="#ffffff"
                mr={2}
                boxShadow="0px 1px 2px rgba(0, 0, 0, 0.1)"
              /> */}
              <Skeleton variant="rounded" height={40} width={50} />
              <InfoIconFilled width={20} height={20} background-color={theme.palette.warning[500]} />
              To be filled/fetched by investor while performing KYC verification
            </Typography> :
              <FilePond
                files={files}
                server={{
                  process: (fieldName, file, metadata, load, error, progress, abort) => {
                    const formData = new FormData();
                    formData.append(fieldName, file, file.name);
                    const controller = new AbortController();
                    fetch('/api/files/files', {
                      method: 'POST',
                      body: formData,
                      headers: {
                        Authorization: `Bearer ${authToken}`,
                      },
                      signal: controller.signal,
                    })
                      .then(async (response) => {
                        const responseData = await response.json();

                        if (!response.ok) {
                          error(responseData.message || 'Upload failed');
                          dispatch(showError(responseData.message || 'Upload failed'));

                          if (response.status === 401) {
                            dispatch(logout());
                          }

                          return;
                        }

                        if (responseData?.name && responseData?.id) {
                          handleFileChange(responseData.name, responseData.id);
                        }

                        onFileUploaded();
                        load(responseData.id);
                      })
                      .catch((err) => {
                        error(err.message || 'Network error');
                        dispatch(showError(err.message || 'Network error'));
                      });

                    return {
                      abort: () => {
                        controller.abort();
                        abort();
                      },
                    };
                  },
                }}
                onaddfilestart={() => {
                  onFileUpload();
                }}
                onaddfile={(error, file) => {
                  if (error) {
                    onFileUploaded();
                  }
                }}
                onprocessfile={(error, file) => {
                  if (error) {
                    if (error?.code === 401) {
                      dispatch(showError(error?.body ?? ""))
                      dispatch(logout());
                    }
                    onFileUploaded();
                  }
                }}
                onupdatefiles={(fileItems) => {
                  setFiles(fileItems);
                }}
                onprocessfilerevert={() => {
                  onFileChange('', '', true);
                }}
                name="file"
                allowPaste={false}
                minFileSize={minFileSize}
                maxFileSize={maxFileSize}
                allowMultiple={multipleFilesCheck === 'false'}
                maxFiles={maxUploadFiles}
                acceptedFileTypes={fileUploadFormats}
                labelIdle={
                  `<div class="handle-label-orientation">
                <div class="filepond-icon"><img src="../../../images/filePondIcon.svg" /></div>
                <div>
                  <span class="filepond--label-action"
                    >Click to Upload
                    <span class="filepond--label-format"
                      >${fileUploadFormats?.map((format) => format?.split('/')[1])?.toString()}
                    </span>
                  </span>
                  <div class="filepond-subheading">
                    ${minFileSize ? `(Min. File Size: ${minFileSize}), ` : ''}(Max. File Size: ${maxFileSize})
                  </div>
                </div>
              </div>
              `}
                labelFileTypeNotAllowed={'Invalid file type'}
                labelMaxFileSize={`Max file size is ${maxFileSize}`}
                labelMinFileSize={`Min file size is ${minFileSize}`}
                fileValidateTypeLabelExpectedTypesMap={{
                  'image/jpeg': '.jpeg',
                  'image/jpg': '.jpg',
                  'image/png': '.png',
                  'application/pdf': '.pdf',
                }}
                imagePreviewHeight={100}
                disabled={disabled}
                styleItemPanelAspectRatio="0.2"
                iconRemove={`
              <div class="delete-icon-container">
                <img src="../../../images/delete-blue.svg"
              </div>
            `}
              >
              </FilePond>}
          </Grid>
          {children}
        </Grid >
      ) : (
        <Grid
          container
          sx={{
            // display: 'flex',
            // justifyContent: 'space-between',
            // alignItems: 'center',
            // border: '1px dashed #AAB2BA',
            border: `0.5px solid ${theme.palette.text.secondary}80`,
            // borderRadius: '6px',
            borderRadius: "10px",
            // mt: '30px',
            // minHeight: '65px',
            padding: "15px 15px 15px 5px",
            background: `${theme.palette.common.white}0D`,
            width: ' 100%',
            margin: 0,
          }}
          columnSpacing="10px"
        >
          <Grid item container justifyContent="center" alignItems="center" xs={2}
            sx={{ display: 'flex', alignItems: 'center' }}
          >
            <CardMedia
              component="img"
              src={documentData.file.thumbnailUrl || '/images/photo-placeholder.jpg'}
              alt="aadhar"
              width="60"
              height="60"
              sx={{
                // display: 'flex',
                // width: 'unset',
                // mx: 1
                objectFit: "contain"
              }}
            />
          </Grid>
          <Grid item container xs={6}>
            {/* <Typography
              component="span"
              sx={{ whiteSpace: 'pre-wrap', overflow: 'hidden', textOverflow: 'ellipsis', flex: 1 }}>
              {documentData.file.name}
            </Typography>
            <Button
              sx={{
                color: `${theme.palette.primary[900]}`,
              }}
              onClick={() => window.open(documentData.file?.viewUrl)}>
              Click to view
            </Button> */}
            <Grid item xs={12}>
              <Typography
                variant='subtitle_500'
                color="text.primary"
              >
                {documentData?.file?.name ?? ""}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography
                variant='overline_400'
                color="text.secondary"
              >
                {formatFileSize(documentData?.file?.size)}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography
                component="span"
                variant='overline_400'
                color="primary.500"
                onClick={() => window.open(documentData.file?.viewUrl)}
                sx={{ cursor: "pointer" }}
              >
                Click to view
              </Typography>
            </Grid>
          </Grid>
          <Grid
            item
            container
            sx={{
              display: 'flex',
              flexDirection: 'column',
            }}
            xs={4}
          >
            {/* <Button
              sx={{
                color: 'primary.main',
                border: '1px dashed #2057A6',
                mb: 1,
              }}
              onClick={() => window.open(documentData.file?.viewUrl)}>
              View
            </Button> */}
            {/* <Grid item container justifyContent="flex-end" alignItems="center" xs={6}> */}
            {/* <IconButton
                sx={{
                  p: 0,
                  pr: 0.5,
                  ':hover': {
                    bgcolor: '#F4FCFC',
                  },
                  cursor: 'pointer',
                  pointerEvents: 'all',
                  mb: 1,
                }}
                onClick={() => window.open(documentData.file?.url, '_blank')}>
                <CardMedia
                  component="img"
                  src={'/images/download-icon.png'}
                  alt="Download"
                  sx={{ width: '25px' }}
                />
              </IconButton> */}
            <Box sx={{
              display: 'flex',
              justifyContent: 'flex-end',
              alignItems: 'flex-start',
              gap: 1,
              flexWrap: 'wrap',
            }}>
              <Box
                onClick={() => window.open(documentData.file?.url, '_blank')}
                sx={{ cursor: "pointer" }}
              >
                <DownloadIcon />
              </Box>
              {/* </Grid> */}
              {!disabled && (
                <>
                  {/* <Grid item container justifyContent="flex-end" alignItems="center" xs={6}> */}
                  {/* <Button
                  variant="outlined"
                  onClick={() => {
                    onFileChange('', '', true);
                  }}
                  sx={(theme: Theme) => ({
                    // mb: 1, 
                    borderRadius: "5px",
                    backgroundColor: theme.palette.primary[50],
                    border: `0.5px solid ${theme.palette.primary[500]}`,
                    color: theme.palette.primary[500],
                    ...theme.typography.subtitle_600,
                    padding: "5px 10px"
                  })}>
                  Replace
                </Button> */}
                  <Tooltip title={documentData?.isThirdPartyFetched ? "Fetched documents cannot be deleted" : ""}>
                    <Box
                      onClick={() => {
                        if (!documentData?.isThirdPartyFetched) {
                          onFileChange('', '', true);
                        }
                      }}
                      sx={{ cursor: documentData?.isThirdPartyFetched ? "not-allowed" : "pointer" }}
                    >
                      <DeleteIcon1 />
                    </Box>
                  </Tooltip>

                  {/* </Grid> */}
                </>
              )}
            </Box>
          </Grid>
        </Grid >
        // <>
        //   <Typography>HI</Typography>
        // </>

      )}
      {
        !!errorText && (
          <Typography
            sx={{
              color: '#d32f2f',
              fontSize: '0.75rem',
            }}>
            {errorText}
          </Typography>
        )
      }
    </>
  );
};

type documentDetails = {
  documentType: string;
  documentName: string;
  documentId: string;
  id?: string | number;
  isActive: boolean;
  file?: FileType;
  loading?: boolean;
  required: string;
  uniqueKey: string;
  options?: string[];
  expiryDate?: Dayjs | null;
  isThirdPartyFetched?: boolean | null;
  url?: string;

  [key: string]: string | number | boolean | FileType | undefined | string[] | null | boolean | Dayjs;
};

type documentProps = {
  documents: {
    documentType: string;
    expiryDate?: Dayjs | null;
    documentName: string;
    documentsList: documentDetails[];
    multipleFiles: string;
    required: string;
    options?: string[];
    uploadFormats: string[];
    maxFiles: number;
    maxFileSize: string;
    minFileSize: string;
    isThirdPartyFetched?: boolean | null;
    url?: string;
    // isDisplay: boolean; //to be uncommented for nexedge
  }[];
  kraDocument?: KraDocumentType[];
  onboardingType?: any;
  permanentAddressEdited?: boolean;
};

type nomineeDocumentProps = {
  nomineedocuments: {
    documentType: string;
    documentName: string;
    documentsList: documentDetails[];
    multipleFiles: string;
    required: string;
    options?: string[];
    uploadFormats: string[];
    maxFiles: number;
    maxFileSize: string;
    minFileSize: string;
  }[];
};
export interface Values {
  applicants: documentProps[];
  nominees: nomineeDocumentProps[];
  saveType: string;
  banks: Bank[];
  hasPOA: boolean;
  [key: string]:
  | documentProps[]
  | string
  | undefined
  | string[]
  | Bank[]
  | boolean
  | nomineeDocumentProps[];
}

interface DocumentObj {
  documentType: string;
  documentName: string;
  documentsList: documentDetails[];
  multipleFiles: string;
  required: string;
  options?: string[];
  uploadFormats: string[];
  maxFiles: number;
  maxFileSize: string;
  minFileSize: string;
}

export const document_object = {
  documentId: '',
  isActive: true,
};

export default function DocumentDetails(): JSX.Element {
  const theme = useTheme();
  const [loading, setLoading] = useState(false);
  const { application } = useSelector((store: RootStateType) => store.application);
  const { role = '' } = useSelector((store: RootStateType) => store.auth);
  const { company = "WMS" } = useSelector((store: RootStateType) => store.navbarInfo)
  const { currencyCode = "INR" } = useSelector((store: RootStateType) => store.currencyInfo);
  const dispatch = useDispatch();
  const history = useHistory();
  const [documentUpload, setDocumentUpload] = useState(false);
  const { path: currentPath } = useRouteMatch();
  const [isRekyc, setIsRekyc] = useState<boolean>(false);
  const isDiyInvestorOnboarding = currentPath?.includes("/investor-onboarding-application")
  const [isShowErrPopup, setShowErrPopup] = useState<boolean>(false);

  const handleUpload = () => {
    setDocumentUpload(true);
  };
  const handleUploaded = () => {
    setDocumentUpload(false);
  };
  const [documentsData, setDocumentsData] = useState<Document>();
  const { enqueueSnackbar } = useSnackbar();

  const nomineeOptOutFormReq = (!DISABLE_NOMINEE_OPY_OUT && application?.doNotWishToNominate) ?? false; //nominee_opt_out

  useEffect(() => {
    (async function () {
      try {
        const response = (await dispatch(getDocuments())) as unknown as Document;
        const modifiedReponse = {
          ...response,
          individual: response.individual.map(obj => {
            if (obj.documentType === "identityProof")
              return { ...obj, documentName: "ID Proof" }
            else
              return obj
          })
        }

        setDocumentsData(modifiedReponse as Document);
        setIsRekyc(`${application?.rekycStatus ?? ''}`.toLowerCase() == 'pending');
      } catch (e) {
        console.error((e as Error).message);
      }
    })();
  }, []);

  const { applicants = [], banks = [], hasPOA = true, nominees = [] } = application || {};
  const { riskProfileGroup, kycMethod = 'osv', addresses } = application?.applicants[0] || {}; // consideration only for primary holder as per tcl so using [0]th index
  const pennyDropVerified = banks?.find((bank) => bank.pennydropVerified)?.defaultBankAccount ?? false;
  const bankRequired = !pennyDropVerified || isOnboardingTypeMinor((applicants[0]?.onboardingType as string) || '') || `${applicants[0]?.status}`.toLowerCase() !== 'individual';
  const permanentAddressSameAsCorresponding = addresses?.find((address) => address.address_type === 'correspondence')?.permanentAddressSameAsCorresponding ?? false;
  const isNri = `${applicants[0]?.status}`.toLowerCase() !== 'individual'
  const getCurrentDocumentValue = (
    currentDocuments: DocumentObj[],
    docType: string,
    index: number
  ) => {
    return currentDocuments.find(doc => doc.documentType === docType)?.documentsList[index]?.documentName ?? "";
  }
  const refactorDocumentArray = (
    doc: DocumentObj,
    currentDocumentType: string,
    documentListIndex: number,
    existingValue: string,
    currentOption: string,
    permanentAddressEdited = false
  ) => {
    if (doc.documentType === 'aadhaar_card') {
      return {
        ...doc,
        documentsList: doc.documentsList.map((obj, index) => {
          return index === documentListIndex ? {
            ...obj,
            required: (existingValue === "Aadhaar Card" || currentOption === 'Aadhaar Card') ? 'false' : 'true'
          } : obj
        }),
        required: (existingValue === "Aadhaar Card" || currentOption === 'Aadhaar Card') ? 'false' : 'true',
        // isDisplay: (existingValue === "Aadhaar Card" || currentOption === 'Aadhaar Card') ? false : true, //to be uncommented for nexedge
      };
    }
    else if (doc.documentType === 'pan_card') {
      return {
        ...doc,
        documentsList: doc.documentsList.map((obj, index) => {
          return index === documentListIndex ? {
            ...obj,
            required: (existingValue === "PAN Card" || currentOption === 'PAN Card') ? 'false' : 'true'
          } : obj
        }),
        required: (existingValue === "PAN Card" || currentOption === 'PAN Card') ? 'false' : 'true',
        // isDisplay: (existingValue === "PAN Card" || currentOption === 'PAN Card') ? false : true,
        //to be uncommented for nexedge
      };
    }
    else if (doc.documentType === currentDocumentType) {
      return {
        ...doc,
        documentsList: doc.documentsList.map((obj, index) => {
          return index === documentListIndex ? {
            ...obj,
            required: (currentOption === "Aadhaar Card" || currentOption === 'PAN Card' || permanentAddressEdited) ? 'true' : 'false'
          } : obj
        }),
        required: (currentOption === "Aadhaar Card" || currentOption === 'PAN Card' || permanentAddressEdited) ? 'true' : 'false'
      };
    }
    return doc;
  }

  const handleIdentityProofChange = (
    applicantIndex: number,
    documentListIndex: number,
    selectedOption: string,
    values: Values,
    setFieldValue: FormikHelpers<Values>['setFieldValue'],
    currentDocumentType: string,
    permanentAddressEdited = false
  ) => {
    const currentDocuments = values.applicants[applicantIndex].documents;

    const currentIdProofValue = getCurrentDocumentValue(currentDocuments, 'identityProof', documentListIndex);
    const currentAddressProofValue = getCurrentDocumentValue(currentDocuments, 'addressProof', documentListIndex);
    const updatedDocuments = currentDocuments.map(
      (doc: DocumentObj) => {
        if (currentDocumentType === "identityProof") {
          return refactorDocumentArray(doc, currentDocumentType, documentListIndex, currentAddressProofValue, selectedOption)
        } else if (currentDocumentType === "addressProof") {
          return refactorDocumentArray(doc, currentDocumentType, documentListIndex, currentIdProofValue, selectedOption, permanentAddressEdited)
        }
      }
    );

    setFieldValue(`applicants.${applicantIndex}.documents`, updatedDocuments);
  };

  const initialValues: Values = {
    applicants: applicants.map((applicant, applicant_index) => {

      const existingIdProofValue = applicant?.documents?.find(obj => obj.documentType === "identityProof")?.documentName ?? ""

      const existingAddressProofValue = applicant?.documents?.find(obj => obj.documentType === "addressProof")?.documentName ?? ""

      const permanentAddressEdited = applicant?.permanentAddressEdited;

      let docData = '';
      if (
        !hasPOA &&
        applicantStatusMasters[applicant.status as string] === applicantStatusMasters.Individual
      ) {
        if (
          onboardingTypeMasters[applicants[0].onboardingType as string] ===
          onboardingTypeMasters.minor
        ) {
          docData = APPLICATION_TYPE_FOR_DOCUMENTS.MINOR;
        } else {
          docData = APPLICATION_TYPE_FOR_DOCUMENTS.INDIVIDUAL;
        }
      }
      if (
        hasPOA &&
        applicantStatusMasters[applicant.status as string] === applicantStatusMasters.Individual
      ) {
        docData = APPLICATION_TYPE_FOR_DOCUMENTS.INDIVIDUAL_POA;
      }
      if (
        !hasPOA &&
        // applicantStatusMasters[applicant.status as string] === applicantStatusMasters.NRI
        (
          applicantStatusMasters[applicant.status as string] === applicantStatusMasters.NRE ||
          applicantStatusMasters[applicant.status as string] === applicantStatusMasters.NRO
        )
      ) {
        if (isOnboardingTypeMinor((applicant.onboardingType as string) || '')) {
          docData = APPLICATION_TYPE_FOR_DOCUMENTS.MINOR_NRI;
        } else {
          docData = APPLICATION_TYPE_FOR_DOCUMENTS.NRI;
        }
      }
      if (
        hasPOA &&
        // applicantStatusMasters[applicant.status as string] === applicantStatusMasters.NRI
        (
          applicantStatusMasters[applicant.status as string] === applicantStatusMasters.NRE ||
          applicantStatusMasters[applicant.status as string] === applicantStatusMasters.NRO
        )
      ) {
        docData = APPLICATION_TYPE_FOR_DOCUMENTS.NRI_POA;
      }
      return {
        documents:
          typeof documentsData !== 'undefined'
            ? ((documentsData as Document)[docData] || [])
              // .map(obj => ({ ...obj, isDisplay: true })) //to be uncommented for nexedge
              .filter((doc) => {
                if (
                  hasPOA &&
                  applicant.applicant_type !== '1' &&
                  doc.documentType === 'poaNotarized'
                ) {
                  return;
                }
                if (!nomineeOptOutFormReq && doc.documentType === 'nominee_opt_out') {
                  return;
                }
                return doc;
              })
              .filter((ele) => ele)
              .filter((document) => {
                if (applicant.amlCheck && document.documentType === 'compliance_document') {
                  return;
                }
                return document;
              })
              .filter((ele) => ele)
              .filter((doc) => {
                if (
                  permanentAddressSameAsCorresponding &&
                  doc.documentType === 'correspondenceAddress' &&
                  !isNri
                ) {
                  return;
                }
                return doc;
              })
              .filter((ele) => ele)
              .map((doc) => {
                if (
                  !permanentAddressSameAsCorresponding &&
                  doc.documentType === 'correspondenceAddress'
                ) {
                  return { ...doc, required: 'true' };
                }
                return doc;
              })
              .map((doc) => {
                if (doc.documentType === 'addressProof') {
                  return { ...doc, required: 'true' };
                }
                return doc;
              })
              .filter((ele) => ele)
              .map((doc) => {
                if (doc.documentType === 'bankAccountProof' && banks?.length <= 0) {
                  return { ...doc, required: 'false' };
                }
                return doc;
              })
              .filter((ele) => ele)
              .map((doc) => {
                if (doc.documentType === 'physical_signed_document' && kycMethod === 'osv') {
                  return { ...doc, required: 'true' }
                }
                return doc;
              })
              .filter((ele) => ele)
              .map((doc) => {
                if (doc.documentType === 'nominee_opt_out') {
                  return {
                    ...doc,
                    required: nomineeOptOutFormReq && [USER_ROLES.INVESTOR].includes(role) ? 'true' : 'false',
                  }
                }
                return doc;
              })
              .filter((ele) => ele)
              // NEEDS TO BE COMMENTED OUT FOR BPI CLIENT START
              .map((doc) => {
                if (doc.documentType === "identityProof") {
                  return { ...doc, required: (existingIdProofValue === "Aadhaar Card" || existingIdProofValue === "PAN Card") ? "true" : "false" }
                }
                // if (doc.documentType === 'addressProof') {
                //   return { ...doc, required: (existingAddressProofValue === "Aadhaar Card" || existingAddressProofValue === "PAN Card" || permanentAddressEdited) ? "true" : "false" }
                // }
                if (doc.documentType === 'aadhaar_card') {
                  return {
                    ...doc,
                    required: (existingIdProofValue === "Aadhaar Card" || existingAddressProofValue === "Aadhaar Card") ? "false" : "true",
                    // isDisplay: (existingIdProofValue === "Aadhaar Card" || existingAddressProofValue === "Aadhaar Card") ? false : true, //to be uncommented for nexedge
                  }
                }
                if (doc.documentType === 'pan_card') {
                  return {
                    ...doc,
                    required: (existingIdProofValue === "PAN Card" || existingAddressProofValue === "PAN Card") ? "false" : "true",
                    // isDisplay: (existingIdProofValue === "PAN Card" || existingAddressProofValue === "PAN Card") ? false : true, //to be uncommented for nexedge
                  }
                }
                // if (doc.documentType === "investorSignature") {
                //   return {
                //     ...doc,
                //     required: (application?.onboardingVia?.toLowerCase() === 'physical' && application?.isBSEEnabled)
                //       || (application?.onboardingVia?.toLowerCase() === 'digital')
                //       ? "true"
                //       : "false"

                //   }
                // }
                if (doc.documentType === "investorSignature") {
                  return {
                    ...doc,
                    required: (kycMethod === 'osv') ? 'true' : 'false'
                  }
                }
                if (doc.documentType === "court_proof_of_guardian") {
                  return { ...doc, required: (applicant?.guardianRelationship === "COURT APPOINTED LEGAL GUARDIAN") ? "true" : "false" }
                }

                // if (doc.documentType === 'physical_signed_document') {
                //   return { ...doc, required: application?.isEsignEnabled === false ? 'true' : 'false' }
                // }
                return doc
              })
              // NEEDS TO BE COMMENTED OUT FOR BPI CLIENT END
              .map((doc: individuals_Poa_nonIndividuals_Documents, index: number) => {

                const {
                  documentType,
                  documentName,
                  multipleFiles,
                  required,
                  options,
                  uploadFormats,
                  maxFiles,
                  maxFileSize,
                  minFileSize,
                  // isDisplay //to be uncommented for nexedge
                  url
                } = doc;
                const { documents: existingDocuments = [] } = applicant || {};
                const docsOfCurrentDocType = existingDocuments
                  .filter((doc) => doc.documentType === documentType)
                  .sort((doc1, doc2) => Number(doc1.documentId) - Number(doc2.documentId));
                return {
                  documentType: documentType,
                  documentName: documentName,
                  documentsList: docsOfCurrentDocType.length
                    ? docsOfCurrentDocType.map((doc, ind) => {
                      const {
                        id,
                        documentName = '',
                        documentType = '',
                        documentId = '',
                        isActive = true,
                        file = undefined,
                        loading = false,
                      } = doc;
                      return {
                        id,
                        applicantId: applicant?.id,
                        documentType,
                        documentName,
                        loading,
                        documentId,
                        isActive,
                        file,
                        options,
                        required,
                        isThirdPartyFetched: doc?.isThirdPartyFetched,
                        uniqueKey: (applicant_index.toString() +
                          '-' +
                          index.toString() +
                          '-' +
                          ind.toString()) as string,
                        expiryDate: doc?.expiryDate ? dayjs(doc?.expiryDate) : null
                      };
                    })
                    : [
                      {
                        documentType,
                        documentName,
                        required,
                        options,
                        uniqueKey: (applicant_index.toString() +
                          '-' +
                          index.toString() +
                          '-' +
                          '0') as string,
                        expiryDate: null,
                        ...document_object,
                      },
                    ],
                  required,
                  multipleFiles,
                  options,
                  uploadFormats,
                  maxFiles,
                  maxFileSize,
                  minFileSize,
                  url
                  // isDisplay //to be uncommented for nexedge
                };
              })
            : [],
        kraDocument: applicant.kraDocument,
        onboardingType: applicant.onboardingType,
        permanentAddressEdited: permanentAddressEdited
      };
    }),
    nominees: nominees.map((nominee, nominee_index) => {
      return {
        nomineedocuments:
          typeof documentsData !== 'undefined'
            ? (isMinor(nominee.dateOfBirth || '')
              ? [
                ...((documentsData as Document)[APPLICATION_TYPE_FOR_DOCUMENTS.NOMINEE_DOC] ||
                  []),
                ...((documentsData as Document)[
                  APPLICATION_TYPE_FOR_DOCUMENTS.NOMINEE_GUARDIAN
                ] || []),
              ].map((doc) => {
                if (doc.documentType === 'nomineeIdProof') {
                  return { ...doc, required: 'false' };
                }
                return doc;
              })
              : (documentsData as Document)[APPLICATION_TYPE_FOR_DOCUMENTS.NOMINEE_DOC] || []
            ).map((doc: individuals_Poa_nonIndividuals_Documents, index: number) => {
              const {
                documentType,
                documentName,
                multipleFiles,
                required,
                options,
                uploadFormats,
                maxFiles,
                maxFileSize,
                minFileSize,
              } = doc;
              const { nomineedocuments: existingDocuments = [] } = nominee || {};
              const docsOfCurrentDocType = existingDocuments
                .filter((doc) => doc.documentType === documentType)
                .sort((doc1, doc2) => Number(doc1.documentId) - Number(doc2.documentId));
              return {
                documentType: documentType,
                documentName: documentName,
                documentsList: docsOfCurrentDocType.length
                  ? docsOfCurrentDocType.map((doc, ind) => {
                    const {
                      id,
                      documentName = '',
                      documentType = '',
                      documentId = '',
                      isActive = true,
                      file = undefined,
                    } = doc;
                    return {
                      id,
                      nomineeId: nominee?.id,
                      documentType,
                      documentName,
                      documentId,
                      isActive,
                      file,
                      options,
                      required,
                      uniqueKey: (nominee_index.toString() +
                        '-' +
                        index.toString() +
                        '-' +
                        ind.toString()) as string,
                    };
                  })
                  : [
                    {
                      documentType,
                      documentName,
                      required,
                      options,
                      uniqueKey: (nominee_index.toString() +
                        '-' +
                        index.toString() +
                        '-' +
                        '0') as string,
                      ...document_object,
                    },
                  ],
                required,
                multipleFiles,
                options,
                uploadFormats,
                maxFiles,
                maxFileSize,
                minFileSize,
              };
            })
            : [],
      };
    }),
    saveType: 'save and proceed',
    banks: banks,
    hasPOA: hasPOA,
  };
  const updatedApplicants = (
    exisitingApplicants: Partial<Applicant>[],
    applicants: documentProps[]
  ): Partial<Applicant>[] => {
    return exisitingApplicants.map((applicant, index) => {
      const { documents = [] } = applicants[index] || {};
      const finalDocs = documents
        // .filter(obj => obj.isDisplay) //to be uncommented for nexedge
        .map((doc) => {
          return doc.documentsList.filter((d) => d.documentId);
        })
        .flat()
        .map((doc) => {
          // eslint-disable-next-line @typescript-eslint/no-unused-vars
          const { uniqueKey, required, ...rest } = doc;
          return {
            ...rest,
            expiryDate: doc?.expiryDate ? doc?.expiryDate?.toISOString() : null
            // id: applicant?.documents?.find((doc) => doc.documentType === rest.documentType)?.id,
            // applicantId: applicant?.id,
          };
        });
      return {
        ...applicant,
        documents: finalDocs,
      };
    }) as Partial<Applicant>[];
  };

  const updatedNominees = (
    existingNominees: NomineeType[],
    nominees: nomineeDocumentProps[]
  ): NomineeType[] => {
    return existingNominees.map((nominee, index) => {
      const { nomineedocuments = [] } = nominees[index] || {};
      const finalDocs = nomineedocuments
        .map((doc) => {
          return doc.documentsList.filter((d) => d.documentId);
        })
        .flat()
        .map((doc) => {
          // eslint-disable-next-line @typescript-eslint/no-unused-vars
          const { uniqueKey, required, ...rest } = doc;
          return {
            ...rest,
            // nomineeId: nominee?.id,
            // id: nominee?.nomineedocuments?.find((doc) => doc.documentType === rest.documentType)
            //   ?.id,
          };
        });
      return {
        ...nominee,
        nomineedocuments: finalDocs,
      };
    }) as NomineeType[];
  };

  const handleSubmit = async (values: Values) => {
    try {
      setLoading(true);
      // const nationalitiesMdmsMasters = (await dispatch(
      //   getNationalityList()
      // )) as unknown as nationaliyType;
      const responseRiskProfile = (await dispatch(
        riskProfileMasterData({
          riskProfileGroup: riskProfileGroup ?? null,
          company: application?.company ?? null
        })
      )) as unknown as RiskProfileMaster;
      const { data: dataMasters } = (await dispatch(getDataMasters())) as unknown as DataMasters;
      const nationalitiesMdmsMasters = { countries: dataMasters?.COUNTRY?.map((list: any) => list?.description) || [] }
      await isFormValidForSubmission(
        application,
        false,
        true,
        nationalitiesMdmsMasters,
        documentsData,
        role,
        responseRiskProfile.riskProfile,
        currencyCode,
        company,
        dataMasters,
        kycMethod,
        permanentAddressSameAsCorresponding,
        bankRequired
      );
      const {
        applicants: exisitingApplicants = [],
        id,
        applicant1ReferenceId,
        currentStep,
        status,
        applicationNumber,
        nominees: existingNominees = [],
      } = application || {};
      const { applicants, saveType, hasPOA, nominees } = values;

      // const updatedApplicants = exisitingApplicants.map((applicant, index) => {
      //   const applicantsWithNoDocsAttached = Object.keys(applicants[index].documents).filter(
      //     (doc) => applicants[index].documents[doc].documentId
      //   );
      //   return {
      //     ...applicant,
      //     countryCode: '+91', //For now hard coding country code. Need to remove after UI is done
      //     documents: applicantsWithNoDocsAttached.map((documentType) => ({
      //       ...getExistingDocuments(exisitingApplicants[index].documents || [], documentType),
      //       ...applicants[index].documents[documentType],
      //     })),
      //   };
      // });

      const updatedApplicantsWithDoc = updatedApplicants(exisitingApplicants, applicants);
      updatedApplicantsWithDoc.map((applicant) => {
        if (applicant.documents?.length) {
          applicant.documents.map((document) => {
            if (document.options && !document.options.includes(document.documentName)) {
              throw `Please Select ${getFieldTitle[document.documentType]}`;
            }
          });
        }
      });

      const updatedNomineesWithDoc = updatedNominees(existingNominees, nominees);
      updatedNomineesWithDoc.map((_nominee) => {
        if (_nominee.nomineedocuments?.length) {
          _nominee.nomineedocuments.map((document) => {
            if (document.options && !document.options.includes(document.documentName)) {
              throw `Please Select ${getFieldTitle[document.documentType]}`;
            }
          });
        }
      });
      const checkApplication = applicationComparison(
        {
          ...application,
          applicants: application?.applicants
            ?.map((applicant) => {
              return {
                ...applicant,
                documents: applicant.documents
                  ?.map((document: any) => {
                    const {
                      documentData,
                      // id,
                      // applicantId,
                      filename,
                      updatedAt,
                      createdAt,
                      updatedBy,
                      createdBy,
                      ...rest
                    } = document;
                    return { ...rest };
                  })
                  .sort((doc1, doc2) => Number(doc1.documentId) - Number(doc2.documentId)),
              };
            })
            .sort((applicant1, applicant2) => Number(applicant1.id) - Number(applicant2.id)),
          nominees: application?.nominees
            ?.map((nominee) => {
              return {
                ...nominee,
                nomineedocuments: nominee.nomineedocuments
                  ?.map((document: any) => {
                    const {
                      documentData,
                      // id,
                      // nomineeId,
                      filename,
                      updatedAt,
                      createdAt,
                      updatedBy,
                      createdBy,
                      ...rest
                    } = document;
                    return { ...rest };
                  })
                  .sort((doc1, doc2) => Number(doc1.documentId) - Number(doc2.documentId)),
              };
            })
            .sort((nominee1, nominee2) => Number(nominee1.id) - Number(nominee2.id)),
        },
        {
          ...application,
          applicants: updatedApplicantsWithDoc
            .map((applicant) => {
              return {
                ...applicant,
                documents: applicant.documents
                  ?.map((document: any) => {
                    const { documentData, options, loading, ...rest } = document;
                    return { ...rest };
                  })
                  .sort((doc1, doc2) => Number(doc1.documentId) - Number(doc2.documentId)),
              };
            })
            .sort((applicant1, applicant2) => Number(applicant1.id) - Number(applicant2.id)),
          nominees: updatedNomineesWithDoc
            .map((nominee) => {
              return {
                ...nominee,
                nomineedocuments: nominee.nomineedocuments
                  ?.map((document: any) => {
                    const { documentData, options, ...rest } = document;
                    return { ...rest };
                  })
                  .sort((doc1, doc2) => Number(doc1.documentId) - Number(doc2.documentId)),
              };
            })
            .sort((nominee1, nominee2) => Number(nominee1.id) - Number(nominee2.id)),
          currentStep: !!currentStep && currentStep > (ONBOARDING_DEMAT_DETAILS ? 10 : 11) ? currentStep : isRekyc ? 10 : Number(currentStep) + 1,
        }
      );
      const isSaveLater = saveType !== 'save and proceed';
      if (id && !checkApplication) {
        const response = await dispatch(
          updateApplication({
            body: {
              ...application,
              applicants: updatedApplicantsWithDoc,
              nominees: updatedNomineesWithDoc,
              // : (status === 'draft' || status === 'sent_to_amc_approver') &&
              // status:
              //   !application?.hasPOA &&
              //     AMC_APPROVER_CHECK_FOR_INDIVIDUAL &&
              //     applyRoleBasedStatus(role) &&
              //     status !== 'draft'
              //     ? 'sent_to_amc_approver'
              //     : status,
              status: sendRoleBasedStatus(role, application?.status as string),
              currentStep: !!currentStep && currentStep > (ONBOARDING_DEMAT_DETAILS ? 10 : 11) ? currentStep : isRekyc ? 10 : Number(currentStep) + 1,
            },
            applicationId: id,
            ...(isSaveLater && {
              toastMessage: '',
            }),
          })
        );

        if (!response) {
          setLoading(false);
          return;
        };

        if (Object.keys(response ?? {}).length) {
          if (isDiyInvestorOnboarding) {
            if (isSaveLater) {
              history.push(`/investor-onboarding-application-details/${id}`)
            } else {
              history.push(`/investor-onboarding-application-preview/${id}`)
            }
            return
          }

          history.push(
            role === USER_ROLES.INVESTOR
              ? `/investment-details/${applicant1ReferenceId}/application-details`
              : role === USER_ROLES.POAAPPROVER || USER_ROLES.AMCAPPROVER === role
                ? `/application-details/${id}`
                : isSaveLater
                  ? `/applications`
                  : `/application-preview/${id}`
          );
        }
      } else if (isSaveLater) {
        enqueueSnackbar(`Application ${applicationNumber} - ` + ' Saved successfully', {
          variant: 'success',
          autoHideDuration: 3000,
        });
        history.push(
          role === USER_ROLES.INVESTOR
            ? `/investment-details/${applicant1ReferenceId}/application-details`
            : role === USER_ROLES.POAAPPROVER || USER_ROLES.AMCAPPROVER === role
              ? isDiyInvestorOnboarding ? `/investor-onboarding-application-details/${id}` : `/application-details/${id}`
              : `/applications`
        );
      } else {
        history.push(
          isDiyInvestorOnboarding ? `/investor-onboarding-application-preview/${id}` :
            role === USER_ROLES.INVESTOR
              ? `/investment-details/${applicant1ReferenceId}/application-details`
              : role === USER_ROLES.POAAPPROVER || USER_ROLES.AMCAPPROVER === role
                ? `/application-details/${id}`
                : `/application-preview/${id}`
        );
      }
    } catch (e) {
      setLoading(false);
      typeof e === 'string' && dispatch(showError(e));
      console.error((e as Error).message);
    } finally {
      setLoading(false);
    }
  };

  const isRMFieldDisabled = [USER_ROLES.RM].includes(role) && kycMethod !== 'osv';
  const getLabel = (
    documentName: string,
    documentType: string,
    required: string,
    values: Values,
    ind: number
  ): string => {
    // return `${documentName}  ${documentType === 'bankAccountProof'
    //   ? ((!isOnboardingTypeMinor((applicants[0]?.onboardingType as string) || '') &&
    //     values.banks.filter((bank) => !bank.pennydropVerified && bank.defaultBankAccount)
    //       .length !== 0) ||
    //     isOnboardingTypeMinor((applicants[0].onboardingType as string) || '')) &&
    //     ind === 0
    //     ? '*'
    //     : ''
    //   : required === 'true'
    //     ? '*'
    //     : ''
    //   } `;

    return `${documentName}  ${required === 'true' ? '*' : ''} `;
  };

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={handleSubmit}
      //validationSchema={documentDetailsSchema}
      validate={(values: Values) => {
        try {
          validateYupSchema(values, documentDetailsSchema(isRMFieldDisabled, kycMethod, permanentAddressSameAsCorresponding, bankRequired), true, values);
        } catch (e) {
          if (isShowErrPopup) {
            setShowErrPopup(false);
            dispatch(showError(`Please fill/upload all required fields`));
          }
          return yupToFormErrors(e);
        }
      }}
      enableReinitialize={true}>
      {({
        handleSubmit,
        values,
        setValues,
        validateForm,
        setTouched,
        setErrors,
        setFieldValue,
        errors
      }) => (
        <Grid
          container
          rowSpacing={3}
          columnSpacing={3}
          component="form"
          noValidate
          onSubmit={handleSubmit}
          alignItems={'center'}
        // sx={{
        //   width: '100%',
        //   ml: 0,
        //   '.MuiGrid-item': { px: { xs: 0, sm: '30px' } },
        // }}
        >
          <Grid item xs={12}>
            {isRMFieldDisabled && <SubHeading sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}><InfoIconFilled width={20} height={20} background-color={theme.palette.warning[500]} /> This tab has to be completely filled by investor before performing the OTP Verification</SubHeading>}
            {!isRMFieldDisabled && <Notes
              displayContent={'Please upload latest documents not more than 2 months old'}
              displayContent1={"Please don't upload any password protected files"}
            />}
          </Grid>
          {values.applicants.map((applicant, ind) => {
            const { documents, permanentAddressEdited = false } = applicant;

            return (
              <>
                <Grid item xs={12}>
                  <SubHeading>Applicant {ind + 1} Document Details</SubHeading>
                </Grid>
                {documents.map((document, doc_index) => {
                  const {
                    documentType,
                    documentName,
                    documentsList = [],
                    multipleFiles,
                    options,
                    required,
                    uploadFormats,
                    maxFiles,
                    maxFileSize,
                    minFileSize,
                    url
                    // isDisplay //to be uncommented for nexedge
                  } = document;
                  if ((`${kycMethod ?? ''}`.toLowerCase() !== 'osv' && !DIGITAL_KYC_DOCS.includes(documentType)) || (kycMethod === 'osv' && ADDRESS_SAME_DOCS.includes(documentType) && permanentAddressSameAsCorresponding)) {
                    return;
                  }
                  if (documentType === 'bankAccountProof' && banks?.length < 0) {
                    return;
                  }
                  return (
                    <Grid key={`mainFrag-${doc_index}`} container sx={{ border: `1px solid ${theme.palette.text.secondary}`, borderRadius: '10px', display: 'flex', flexDirection: 'row', margin: '20px 0 20px 40px', padding: '20px', gap: '10px', justifyContent: 'space-between' }}>
                      <Grid
                        item
                        xs={12}
                        lg={6}
                        sx={{ '& .MuiGrid-item': { paddingTop: '0 !important' } }}
                      >
                        {options &&
                          documentsList.map((doc, index) => {
                            return (
                              <React.Fragment key={`internalFrag-${index}`} >
                                <Grid xs={12} sm={12} sx={{ paddingTop: '0', padding: '0' }}>
                                  {/* <Typography
                                  variant='body_500'
                                  color={isRMFieldDisabled && (!(documentType === 'bankAccountProof' && banks?.length > 0)) ? theme.palette.text.disabled : theme.palette.text.primary}
                                >
                                  {getLabel(
                                    documentName,
                                    documentType,
                                    required,
                                    values,
                                    ind
                                  )}
                                </Typography> */}
                                  <SearchableSelect
                                    name={`applicants.${ind}.documents.${doc_index}.documentsList.${index}.documentName`}
                                    label={documentType !== 'bankAccountProof' ?
                                      getLabel(
                                        documentName,
                                        documentType,
                                        required,
                                        values,
                                        ind
                                      ) :
                                      `${documentName}  ${(required === 'true' && bankRequired) ? '*' : ''} `
                                    }
                                    items={options.map((item: string) => ({
                                      key: item,
                                      value: item,
                                    }))}
                                    // applyLabelStyles={true}
                                    disabled={isRMFieldDisabled && (!(documentType === 'bankAccountProof' && banks?.length > 0))}
                                    onChange={async (event) => {
                                      await setErrors({}) //needs to be commented for BPI client

                                      //needs to be commented for BPI client start
                                      if (documentType === 'identityProof' || documentType === 'addressProof') {
                                        handleIdentityProofChange(ind, index, event.target.value as string, values, setFieldValue, documentType, permanentAddressEdited);
                                      }
                                      //needs to be commented for BPI client end
                                      setFieldValue(
                                        `applicants.${ind}.documents.${doc_index}.documentsList.${index}.documentName`,
                                        event.target.value
                                      );
                                    }}

                                  />
                                  {/* <TextDatePicker
                                  name={`applicants.${ind}.documents.${doc_index}.documentsList.${index}.expiryDate`}
                                  label="Expiry Date"
                                  inputLabelStyles={{
                                    transform: 'unset',
                                    fontSize: 14,
                                    fontWeight: 500,
                                    color: 'rgba(0,0,0,0.7)',
                                  }}
                                  placeholder=''
                                  disabled={false}
                                  maxDate={new Date("2099-12-31")}
                                /> */}
                                </Grid>
                              </React.Fragment>
                            )
                          })}
                        {!options && (
                          <>
                            <Typography
                              color={isRMFieldDisabled && (!(documentType === 'bankAccountProof' && banks?.length > 0)) && documentType !== 'court_proof_of_guardian' && documentType !== 'nominee_opt_out' && documentType.toLowerCase() !== 'additional' ? theme.palette.text.disabled : theme.palette.text.primary}
                              sx={{
                                // color: `${theme.palette.text.primary}`,
                                fontWeight: 500,
                                fontSize: '16px',
                                fontFamily: `${theme.typography.fontFamily}`,
                                // mt: documentType === 'investorSignature' ? 6 : 8,
                              }}>
                              {documentName} {required === 'true' ? '*' : ''}
                              {documentType === 'investorSignature' && (
                                <Typography
                                  color={isRMFieldDisabled ? theme.palette.text.disabled : theme.palette.text.secondary}
                                  sx={{
                                    // color: `${theme.palette.text.secondary}`,
                                    fontWeight: 400,
                                    fontSize: 14,
                                    fontFamily: `${theme.typography.fontFamily}`
                                  }}>
                                  (This signature copy is used as a verification process for future
                                  redemptions and transfer requests)
                                </Typography>
                              )}
                              {ind === 0 && documentType === "nominee_opt_out" && nomineeOptOutFormReq && (
                                <>
                                  <br></br>
                                  {url && (
                                    <Button
                                      variant="contained"
                                      sx={{ p: 0.8, mt: 1 }}
                                      onClick={() => window.open(`${window.location.origin}` + url, '_blank')}
                                    >
                                      <Typography variant='overline_400'>Download {documentName}</Typography>
                                    </Button>
                                  )}
                                </>
                              )}
                            </Typography>


                            {/* {
                              documentsList.map((doc, index) => (
                                <>
                                  <TextDatePicker
                                    name={`applicants.${ind}.documents.${doc_index}.documentsList.${index}.expiryDate`}
                                    label="Expiry Date"
                                    inputLabelStyles={{
                                      transform: 'unset',
                                      fontSize: 14,
                                      fontWeight: 500,
                                      color: 'rgba(0,0,0,0.7)',
                                    }}
                                    placeholder=''
                                    disabled={false}
                                    maxDate={new Date("2099-12-31")}
                                  />
                                </>
                              ))} */}
                          </>
                        )}
                      </Grid>
                      <Grid
                        item
                        container
                        xs={12}
                        lg={5}
                        display="flex"
                        flexDirection="column"
                        sx={{ rowGap: "10px" }}
                      // sx={{ display: isDisplay ? 'block' : 'none' }} //to be uncommented for nexedge
                      >
                        {documentsList.map((doc, index) => {
                          if ((`${kycMethod ?? ''}`.toLowerCase() !== 'osv' && (!DIGITAL_KYC_DOCS.includes(documentType))) || (kycMethod === 'osv' && ADDRESS_SAME_DOCS.includes(documentType) && permanentAddressSameAsCorresponding)) return;
                          return (
                            <React.Fragment key={doc.uniqueKey}>
                              <FileUpload
                                onFileChange={(value, documentId, removeFile) => {
                                  const { file, ...rest } =
                                    values.applicants[ind].documents[doc_index].documentsList[index];
                                  setFieldValue(
                                    `applicants.${ind}.documents.${doc_index}.documentsList.${index}`,
                                    {
                                      ...rest,
                                      documentId,
                                      ...(!removeFile && { file }),
                                    }
                                  );
                                }}
                                name={`applicants.${ind}.documents.${doc_index}.documentsList.${index}.documentId`}
                                documentData={doc}
                                disabled={isRMFieldDisabled && ((!(documentType === 'bankAccountProof' && banks?.length > 0) && documentType !== 'court_proof_of_guardian' && documentType.toLowerCase() !== 'additional'))}
                                onFileUpload={handleUpload}
                                onFileUploaded={handleUploaded}
                                fileUploadFormats={uploadFormats}
                                maxUploadFiles={maxFiles}
                                maxFileSize={maxFileSize}
                                minFileSize={minFileSize}
                                multipleFilesCheck={multipleFiles}
                              >
                                {[
                                  'identityProof',
                                  'aadhaar_card',
                                  'addressProof',
                                  'correspondenceAddress',
                                  'nominee_opt_out'
                                ].includes(doc.documentType) && (
                                    <Grid container item justifyContent="flex-end">
                                      {/* <LoadingButton
                                          loadingPosition="start"
                                          type="submit"
                                          loading={
                                            values.applicants[ind].documents[doc_index].documentsList[index]
                                              .loading
                                          }
                                          variant="contained"
                                          sx={(theme: Theme) => ({
                                            // mt: 1,
                                            // float: 'right',
                                            // fontSize: 15,
                                            // pl: values.applicants[ind].documents[doc_index].documentsList[
                                            //   index
                                            // ].loading
                                            //   ? 5
                                            // : 1,
                                            // py: 0.5,
                                            // cursor:
                                            //   !doc.documentName.includes('Aadhaar Card') ||
                                            //     doc.documentId === ''
                                            //     ? 'none'
                                            //     : 'pointer',
                                            ...theme.typography.subtitle_600,
                                            color: theme.palette.primary[500],
                                            backgroundColor: theme.palette.primary[50],
                                            borderRadius: "5px",
                                            border: `0.5px solid ${theme.palette.primary[500]}`,
                                            padding: "5px 15px",
                                            '&:hover': {
                                              backgroundColor: theme.palette.primary[50],
                                              opacity: 0.7
                                            },
                                            "&.Mui-disabled": {
                                              border: "none"
                                            }
                                          })}
                                          onClick={async () => {
                                            try {
                                              setFieldValue(
                                                `applicants.${ind}.documents.${doc_index}.documentsList.${index}.loading`,
                                                true
                                              );
                                              const maskedAadhaarResponse = (await dispatch(
                                                getMaskedAadhaar({
                                                  fileId: doc.documentId,
                                                  applicationId: application?.id || '',
                                                  applicantId: application?.applicants[ind].id || '',
                                                })
                                              )) as unknown as MaskedAadhaarResponse;
                                              const { loading, file, ...rest } =
                                                values.applicants[ind].documents[doc_index].documentsList[
                                                index
                                                ];
                                              setFieldValue(
                                                `applicants.${ind}.documents.${doc_index}.documentsList.${index}`,
                                                {
                                                  ...rest,
                                                  loading: false,
                                                  documentId: maskedAadhaarResponse.id,
                                                  ...(rest.id && { file }),
                                                }
                                              );
                                              if (maskedAadhaarResponse.id) {
                                                enqueueSnackbar('Aadhaar masked Successfully', {
                                                  variant: 'success',
                                                  autoHideDuration: 3000,
                                                });
                                              }
                                            } catch (e) {
                                              setFieldValue(
                                                `applicants.${ind}.documents.${doc_index}.documentsList.${index}.loading`,
                                                false
                                              );
                                              console.error((e as Error).message);
                                            }
                                          }}
                                          disabled={
                                            !doc.documentName.includes('Aadhaar Card') ||
                                            doc.documentId === '' ||
                                            isFieldDisabled
                                          }>
                                          Mask Aadhaar
                                        </LoadingButton> */}
                                      {
                                        !isRMFieldDisabled && (!(documentType === 'bankAccountProof' && banks?.length > 0)) && (<LoadingButton
                                          type="submit"
                                          loading={
                                            values.applicants[ind].documents[doc_index].documentsList[index].loading
                                          }
                                          variant="contained"
                                          sx={(theme: Theme) => ({
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            ...theme.typography.subtitle_600,
                                            color: theme.palette.primary[500],
                                            backgroundColor: theme.palette.primary[50],
                                            borderRadius: "5px",
                                            border: `0.5px solid ${theme.palette.primary[500]}`,
                                            padding: "5px 10px",
                                            '&:hover': {
                                              backgroundColor: theme.palette.primary[50],
                                              opacity: 0.7
                                            },
                                            "&.Mui-disabled": {
                                              border: "none"
                                            }
                                          })}
                                          onClick={async () => {
                                            try {
                                              setFieldValue(
                                                `applicants.${ind}.documents.${doc_index}.documentsList.${index}.loading`,
                                                true
                                              );
                                              const maskedAadhaarResponse = (await dispatch(
                                                getMaskedAadhaar({
                                                  fileId: doc.documentId,
                                                  applicationId: application?.id || '',
                                                  applicantId: application?.applicants[ind].id || '',
                                                })
                                              )) as unknown as MaskedAadhaarResponse;
                                              const { loading, file, ...rest } =
                                                values.applicants[ind].documents[doc_index].documentsList[
                                                index
                                                ];
                                              setFieldValue(
                                                `applicants.${ind}.documents.${doc_index}.documentsList.${index}`,
                                                {
                                                  ...rest,
                                                  loading: false,
                                                  documentId: maskedAadhaarResponse.id,
                                                  ...(rest.id && { file }),
                                                }
                                              );
                                              if (maskedAadhaarResponse.id) {
                                                enqueueSnackbar('Aadhaar masked Successfully', {
                                                  variant: 'success',
                                                  autoHideDuration: 3000,
                                                });
                                              }
                                            } catch (e) {
                                              setFieldValue(
                                                `applicants.${ind}.documents.${doc_index}.documentsList.${index}.loading`,
                                                false
                                              );
                                              console.error((e as Error).message);
                                            }
                                          }}
                                          disabled={
                                            !doc.documentName.includes('Aadhaar Card') ||
                                            doc.documentId === '' ||
                                            isRMFieldDisabled && (!(documentType === 'bankAccountProof' && banks?.length > 0))
                                          }>
                                          {values.applicants[ind].documents[doc_index].documentsList[index].loading && (
                                            <CircularProgress size={20} color="inherit" />
                                          )}

                                          Mask Aadhaar

                                        </LoadingButton>)
                                      }


                                    </Grid>
                                  )}
                              </FileUpload>
                              {index > 0 && !doc.documentId && (
                                <DeleteOutlineIcon
                                  onClick={() => {
                                    const getDocs = values.applicants[ind].documents[
                                      doc_index
                                    ].documentsList.filter((_: any, i: number) => i !== index);
                                    setFieldValue(
                                      `applicants.${ind}.documents.${doc_index}.documentsList`,
                                      getDocs
                                    );
                                  }}
                                  color="error"
                                  sx={{
                                    alignSelf: 'end',
                                    position: 'relative',
                                    bottom: '90px',
                                    left: '22px',
                                    cursor: 'pointer',
                                  }}
                                />
                              )}
                            </React.Fragment>
                          )
                        })}
                        {multipleFiles === 'true' && (documentType.toLowerCase() === 'additional' || documentsList.length < 2) && (
                          <Typography
                            onClick={() => {
                              const currentDocTypeListLength =
                                values.applicants[ind].documents[doc_index].documentsList.length;
                              const {
                                required = true,
                                documentType,
                                documentName,
                                documentId,
                              } = values.applicants[ind].documents[doc_index].documentsList[
                                currentDocTypeListLength - 1
                                ];
                              try {
                                if (!documentId) {
                                  throw Error(
                                    'Please upload the first document to add more documents'
                                  );
                                }
                                setFieldValue(
                                  `applicants.${ind}.documents.${doc_index}.documentsList`,
                                  [
                                    ...values.applicants[ind].documents[doc_index].documentsList,
                                    {
                                      ...document_object,
                                      uniqueKey:
                                        ind.toString() +
                                        '-' +
                                        doc_index.toString() +
                                        '-' +
                                        currentDocTypeListLength.toString(),
                                      documentType,
                                      documentName,
                                      required,
                                    },
                                  ]
                                );
                              } catch (e) {
                                dispatch(showError((e as Error).message));
                              }
                            }}
                            sx={{
                              color: '#417850',
                              fontSize: '12px',
                              fontWeight: 500,
                              textDecoration: 'underline',
                              alignSelf: 'end',

                              // position: 'relative',
                              // bottom:
                              //   values.applicants[ind].documents[doc_index].documentsList[
                              //     values.applicants[ind].documents[doc_index].documentsList.length - 1
                              //   ].documentId !== ''
                              //     ? '15px'
                              //     : '50px',

                              // pointerEvents: applicant.documents[
                              //   values.applicants[ind].documents.length - 1
                              // ].documentId
                              //   ? 'all'
                              //   : 'none',
                              cursor: 'pointer',
                            }}>
                            {'Add another document'}
                          </Typography>
                        )}
                      </Grid >
                    </Grid>
                  );
                })}
                {ENABLE_KRA_DOCUMENT_FETCH && USER_ROLES.INVESTOR !== role && (
                  <KraDocument KraDocument={applicant.kraDocument} />
                )}

              </>
            );
          })}

          {values.nominees.map((nominee, ind) => {
            const { nomineedocuments } = nominee;
            if (kycMethod !== 'osv') return;
            return (
              <>
                <Grid item xs={12}>
                  <SubHeading> {getApplicantName(ind + 1, true)} Nominee Document Details</SubHeading>
                </Grid>
                {nomineedocuments.map((document, doc_index) => {
                  const {
                    documentType,
                    documentName,
                    documentsList = [],
                    multipleFiles,
                    options,
                    required,
                    uploadFormats,
                    maxFiles,
                    maxFileSize,
                    minFileSize,
                  } = document;
                  return (
                    <React.Fragment key={`nomineeFrag-${ind}`}>
                      <Grid item xs={12} lg={6}>
                        {options &&
                          documentsList.map((doc, index) => (
                            <React.Fragment key={`nomDocFrag-${index}`}>
                              <Grid xs={12} sm={12}>
                                <MFSelectField
                                  name={`nominees.${ind}.nomineedocuments.${doc_index}.documentsList.${index}.documentName`}
                                  label={getLabel(
                                    documentName,
                                    documentType,
                                    required,
                                    values,
                                    ind
                                  )}
                                  items={options.map((item: string) => ({
                                    key: item,
                                    value: item,
                                  }))}
                                  disabled={isRMFieldDisabled}
                                  applyLabelStyles={true}
                                />
                                {/* <TextDatePicker
                                  name="riskProfileDeclarationDate"
                                  label="Expiry Date *"
                                  inputLabelStyles={{
                                    transform: 'unset',
                                    fontSize: 14,
                                    fontWeight: 500,
                                    color: 'rgba(0,0,0,0.7)',
                                  }}
                                  placeholder=''
                                  disabled={false}
                                /> */}
                              </Grid>
                            </React.Fragment>
                          ))}
                        {!options && (
                          <>
                            <Typography
                              sx={{
                                color: 'primary.main',
                                fontWeight: 500,
                                mt: documentType === 'investorSignature' ? 4 : 6,
                              }}>
                              {documentName} {required === 'true' ? '*' : ''}
                            </Typography>
                            {/* <TextDatePicker
                              name="riskProfileDeclarationDate"
                              label="Expiry Date *"
                              inputLabelStyles={{
                                transform: 'unset',
                                fontSize: 14,
                                fontWeight: 500,
                                color: 'rgba(0,0,0,0.7)',
                              }}
                              placeholder=''
                              disabled={false}
                            /> */}
                          </>

                        )}
                      </Grid>
                      <Grid item xs={12} lg={6}>
                        {documentsList.map((doc, index) => (
                          <React.Fragment key={`subFrag-${doc.uniqueKey}`}>
                            <FileUpload
                              onFileChange={(value, documentId, removeFile) => {
                                const { file, ...rest } =
                                  values.nominees[ind].nomineedocuments[doc_index].documentsList[
                                  index
                                  ];
                                setFieldValue(
                                  `nominees.${ind}.nomineedocuments.${doc_index}.documentsList.${index}`,
                                  {
                                    ...rest,
                                    documentId,
                                    ...(!removeFile && { file }),
                                  }
                                );
                              }}
                              name={`nominees.${ind}.nomineedocuments.${doc_index}.documentsList.${index}.documentId`}
                              documentData={doc}
                              disabled={isRMFieldDisabled}
                              onFileUpload={handleUpload}
                              onFileUploaded={handleUploaded}
                              fileUploadFormats={uploadFormats}
                              maxUploadFiles={maxFiles}
                              maxFileSize={maxFileSize}
                              minFileSize={minFileSize}
                              multipleFilesCheck={multipleFiles}
                            />
                          </React.Fragment>
                        ))}
                      </Grid>
                    </React.Fragment>
                  );
                })}
              </>
            );
          })
          }

          <Grid item xs={12} my={2} />
          <ProceedSaveLater
            // saveButtonText={
            //   isFieldDisabled || USER_ROLES.AMCAPPROVER === role ? 'Save Application' : 'Continue'
            // }
            saveButtonText={'Continue'}
            // saveButtonText={
            //   isFieldDisabled || USER_ROLES.AMCAPPROVER === role
            //     ? 'Save Application'
            //     : values.hasPOA
            //     ? 'Send to POA Approver'
            //     : // : (application?.status === 'draft' ||
            //     //     application?.status === 'sent_to_amc_approver') &&
            //     AMC_APPROVER_CHECK_FOR_INDIVIDUAL && applyRoleBasedStatus(role)
            //     ? 'Send to Checker'
            //     : 'Send to Investor'
            // }
            showEndIcon={false}
            saveLater={() => {
              setShowErrPopup(true);
              setFieldValue('saveType', 'save for later');
            }}
            // saveAndProceed={async () => {
            //   try {
            //     if (![USER_ROLES.INVESTOR, USER_ROLES.POAAPPROVER].includes(role)) {
            //       await isFormValidForSubmission(application, false);
            //       const error = await validateForm();
            //       if (!Object.keys(error).length) {
            //         history.push(`/application-details/${application?.id}`);
            //         //setDialog(true);
            //       }
            //       setTouched(setNestedObjectValues(error, true));
            //       setErrors(error);
            //     }
            //   } catch (e) {
            //     dispatch(showError(e as string));
            //   }
            // }}
            //saveAndProceedType={isFieldDisabled ? 'submit' : 'button'}
            loader={loading}
            clickedButton={values.saveType}
            // showSaveForLater={
            //   isFieldDisabled ? false : USER_ROLES.AMCAPPROVER === role ? false : true
            // }
            showSaveForLater={true}
            disabled={documentUpload}
            saveAndProceed={() => {
              setShowErrPopup(true);
              setFieldValue('saveType', 'save and proceed');
            }}

          />
        </Grid >
      )}
    </Formik >
  );
}
